import Vue from 'vue'
import VueBrowserDetect from 'vue-browser-detect-plugin'

Vue.use(VueBrowserDetect)
